import { render, staticRenderFns } from "./updateModule.vue?vue&type=template&id=fac85ca0&"
import script from "./updateModule.vue?vue&type=script&lang=js&"
export * from "./updateModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports